module.exports = {
  model: { id: '', boarding_points: [], identification: null },
}
